import React from 'react';
import { Hero } from './components/Hero';
import { ExtendedTestimonials, StatsAndProof } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2riknh5rqsbbj">
      <MetaPixel data-id="element-1" data-mp="2mjpuxc3z38e8" />
      <Hero data-id="element-2" data-mp="31aqeac69cmp5" />
      <StatsAndProof data-id="element-3" data-mp="31agoopp4khjz" />
      <PainPoints data-id="element-4" data-mp="31ayvgg9eye65" />
      <ProductOffer data-id="element-5" data-mp="31c9vc4zqn1rz" />
      <Pricing showAnchor data-id="element-6" data-mp="31ctd9lpe1q60" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wka20ve6b74d" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wiyxgtcwlvc7" />
      <CostSection data-id="element-9" data-mp="2wifc12o1ootf" />
      <Pricing data-id="element-10" data-mp="2wi5mthatqlos" />
      <FooterAndProofPopup data-id="element-11" data-mp="28ufm24yk52fw" />
    </main>;
}